export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';

import { logOut } from './auth';

import { getUserProfile } from '../api';

export const fetchUserProfile = () => dispatch => {
  return dispatch({
    type: FETCH_USER_PROFILE,
    payload: getUserProfile().catch(
      (e) => {
        if (e.response && e.response.status === 401) {}
        // just sign out for now
        dispatch(logOut());
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/actions/currentUser.js